const Footer = (props) => {

    // Can't simply pull-in header HTML since AWS Bucket CORs settings block it (it's NOT a PUBLIC API). Have to call in script using <script> in <meta> - "crossorigin" attribute is omitted, so those resources can be used without CORs error.
    // If you're going to pull-in using fetch(), don't forget to add proxy to package.json - to avoid CORs error (https://www.telerik.com/blogs/dealing-with-cors-in-create-react-app)
    
    return(
        <></>
    );
}

export default Footer;